import { dsToast } from '@frontends/ds';

export const showToast = ({
  type,
  title,
  description,
}: {
  type?: 'success' | 'error';
  title: string;
  description: string;
}) => {
  const content = { title, description };

  if (type === 'success') {
    dsToast.success(content);
  } else if (type === 'error') {
    dsToast.danger(content);
  } else {
    dsToast.info(content);
  }
};
